<mat-card>
    <mat-card-header fxLayoutAlign="center">                
        <mat-card-subtitle><h2>Mes Profits</h2></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="space-around">
            <button mat-flat-button [matMenuTriggerFor]="menu1" color="primary" class="ml-2">
                {{currentYear}} <mat-icon>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #menu1="matMenu" class="p-2">
                <div class="d-flex align-content-start flex-wrap" style="height: 120px">
                    <span *ngFor="let items of years">
                        <button class="m-2" mat-stroked-button color="primary" (click)="onSelect(items)">
                            {{items}}
                        </button>
                    </span>
                </div>
            </mat-menu>
        </div>
        <div class="w-100 h-300p" #resizedDiv *ngIf="dataChartUpdating == null;else elseBlock">
            <ngx-charts-line-chart
                [scheme]="colorScheme"
                [results]="(dataChart$ | async)?.profitInCurrentYear"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
                [autoScale]="autoScale"
                [roundDomains]="roundDomains"
                (select)="onSelect($event)">
            </ngx-charts-line-chart>             
        </div>
        <ng-template #elseBlock>
            <div class="w-100 h-300p" #resizedDiv>
                <ngx-charts-line-chart
                    [scheme]="colorScheme"
                    [results]="dataChartUpdating"
                    [gradient]="gradient"
                    [xAxis]="showXAxis"
                    [yAxis]="showYAxis"
                    [legend]="showLegend"
                    [showXAxisLabel]="showXAxisLabel"
                    [showYAxisLabel]="showYAxisLabel"
                    [xAxisLabel]="xAxisLabel"
                    [yAxisLabel]="yAxisLabel"
                    [autoScale]="autoScale"
                    [roundDomains]="roundDomains"
                    (select)="onSelect($event)">
                </ngx-charts-line-chart>             
            </div>
        </ng-template>

    </mat-card-content>
</mat-card>